import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-license-information-content',
    templateUrl: './license-information-content.component.html',
    styleUrls: ['./license-information-content.component.css']
})
export class LicenseInformationContentComponent implements OnChanges {

    @Input()
    public feature: string;

    public featureTitle: string;
    public featureText: string;
    public featureWiki: string;

    constructor(
        public translate: TranslateService
    ) { }

    ngOnChanges(changes: SimpleChanges): void {
        this.translate.get(`license.information.${this.feature}.title`).subscribe(result => {
            this.featureTitle = result;
        });

        this.translate.get(`license.information.${this.feature}.text`).subscribe(result => {
            this.featureText = result;
        });

        this.translate.get(`license.information.${this.feature}.wiki`).subscribe(result => {
            this.featureWiki = result;
        });
    }
}
